import { Check } from "lucide-react";
import { useI18n } from "@/i18n/LanguageContext";
import { Reveal } from "@/components/site/Reveal";
import { SectionHeading } from "@/components/site/SectionHeading";

export const Outcomes = () => {
  const { t } = useI18n();
  const o = t.outcomes;
  return (
    <section className="bg-gradient-ivory">
      <div className="container-site section-pad py-20 md:py-24">
        <SectionHeading eyebrow={o.eyebrow} title={o.title} />
        <div className="mt-10 grid gap-4 sm:grid-cols-2">
          {o.items.map((item, i) => (
            <Reveal
              key={i}
              delay={i * 0.06}
              className={`flex h-full items-start gap-4 rounded-xl border border-border bg-card p-5 shadow-card transition-shadow duration-300 hover:shadow-elevated ${
                i === o.items.length - 1 && o.items.length % 2 !== 0 ? "sm:col-span-2" : ""
              }`}
            >
              <span className="mt-0.5 flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-teal/12 text-teal">
                <Check className="h-4 w-4" />
              </span>
              <p className="text-sm leading-relaxed text-foreground/90">{item}</p>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
